<template>
  <div id="SuccessfulCase">
    <div class="case">
      <main>
        <img src="../assets/Conversion/construction.png">
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessfulCase",
  data() {
    return {
      
    };
  }
};
</script>
<style lang="less" scoped>
.case {
  main{
    width: 100%;
    height: 7rem;
    position: relative;
    img{
      width: 4.67rem;
      height: 3.9rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      // display: block;
      // margin: 0 auto;
    }
  }
}
</style>